import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import "../../assets/custom_styles.css";
import Logo1 from "../../assets/img/Cancer Institute_logo.png";
import Logo2 from "../../assets/img/TN-CReSt_logo.png";
import { AuthContext } from "../AuthContext";

const Header = () => {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const [selectType, setSelectType] = useState("today");
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Login Authentication
    const authToken = sessionStorage.getItem("token");
    setIsAuthenticated(!!authToken);
  });

  useEffect(() => {
    const storedType = JSON.parse(sessionStorage.getItem("visual_type"));
    if (storedType) {
      setSelectType(storedType);
    } else {
      sessionStorage.setItem("visual_type", JSON.stringify("today"));
      setSelectType("today");
    }
  }, []);

  // close mobile menu when route changes
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleDataVisualizationClick = (e) => {
    e.preventDefault();
    // Clear other types and set to "today"
    sessionStorage.setItem("visual_type", JSON.stringify("today"));
    setSelectType("today");
    navigate("/Visualization");
  };

  const handleLogout = () => {
    // Logout
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userDetails");
    sessionStorage.removeItem("visual_type");
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <header className="container-fluid shadow pt-1 mb-2 sticky-top bg-white rounded-3">
      <div className="container">
        {/* Desktop Header */}
        <div className="row pt-2 mb-3 align-items-center d-none d-md-flex">
          {/* Logo 1 - Left */}
          <div className="col-2 d-flex justify-content-start align-items-center">
            <Link to="/">
              <img
                src={Logo1}
                alt="header_logo1"
                style={{ maxHeight: "80px", width: "auto" }}
                className="img-fluid"
              />
            </Link>
          </div>
          {/* Title - Center */}
          <div className="col-8 d-flex flex-column justify-content-center align-items-center text-center">
            <h3 className=" fw-bold text-primary mb-2">
              TAMIL NADU CANCER REGISTRY STATISTICS(TN-CReSt)
            </h3>
            <h4 className="fw-semibold text-primary mb-0">
              Analytics For Action Against Cancer
            </h4>
          </div>
          {/* <div>
              <h4>Analytics For Action Against Cancer</h4>
            </div> */}
          {/* Logo 2 - Right */}
          <div className="col-2 d-flex justify-content-end align-items-center">
            <Link to="/">
              <img
                src={Logo2}
                alt="header_logo2"
                style={{ maxHeight: "80px", width: "auto" }}
                className="img-fluid"
              />
            </Link>
          </div>
        </div>

        {/* Mobile Header: Only Logo2 (left) and hamburger (right) */}
        <div
          className="d-flex d-md-none flex-row align-items-center justify-content-between py-2 px-2"
          style={{ minHeight: 0 }}
        >
          {/* Logo2 - left */}
          <Link to="/">
            <img
              src={Logo2}
              alt="header_logo2"
              style={{ maxHeight: "42px", width: "auto" }}
              className="img-fluid"
            />
          </Link>
          {/* Hamburger menu - right */}
          <button
            className="menu-toggle ms-auto"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen((s) => !s)}
            type="button"
          >
            <span>
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
              <span className="hamburger-bar"></span>
            </span>
          </button>
        </div>

        {/* Mobile slide-down menu (visible on small screens) */}
        <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
          <div className="mobile-links">
            <Link
              to={"/"}
              className={location.pathname === "/" ? "active" : ""}
              onClick={() => setMobileOpen(false)}
            >
              Home
            </Link>
            <Link
              to={"/Factsheets"}
              className={location.pathname === "/Factsheets" ? "active" : ""}
              onClick={() => setMobileOpen(false)}
            >
              FactSheets
            </Link>
            <button
              onClick={(e) => {
                e.preventDefault();
                setMobileOpen(false);
                handleDataVisualizationClick(e);
              }}
            >
              DataVisualization
            </button>
            <Link
              to={"/pages/initiative"}
              className={
                location.pathname === "/pages/initiative" ? "active" : ""
              }
              onClick={() => setMobileOpen(false)}
            >
              Initiatives
            </Link>
            <Link
              to={"/pages/methods"}
              className={location.pathname === "/pages/methods" ? "active" : ""}
              onClick={() => setMobileOpen(false)}
            >
              Methods
            </Link>
            <Link
              to={"/pages/help"}
              className={location.pathname === "/pages/help" ? "active" : ""}
              onClick={() => setMobileOpen(false)}
            >
              Help
            </Link>
            {!isAuthenticated ? (
              <Link
                to={"/Login"}
                className={location.pathname === "/Login" ? "active" : ""}
                onClick={() => setMobileOpen(false)}
              >
                Login
              </Link>
            ) : (
              <>
                <Link to={"/Profile"} onClick={() => setMobileOpen(false)}>
                  Profile
                </Link>
                <Link
                  to={"/Changepassword"}
                  onClick={() => setMobileOpen(false)}
                >
                  Change Password
                </Link>
                <button
                  onClick={() => {
                    setMobileOpen(false);
                    handleLogout();
                  }}
                >
                  Logout
                </button>
              </>
            )}
          </div>
        </div>

        <nav>
          <div className="row">
            {/* Desktop / tablet nav (hidden on small) */}
            <div className="col overflow-hidden">
              <ul className="nav d-flex flex-end d-none d-md-flex flex-md-nowrap nav-tablet-nowrap w-100">
                <li className="nav-item text-grey fs-5">
                  <Link
                    className={` nav-link custom-nav ${
                      location.pathname === "/"
                        ? " active text-primary"
                        : "nav-link  text-grey fs-5 text-decoration-none"
                    }`}
                    to={"/"}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item text-grey fs-5">
                  <Link
                    className={` nav-link custom-nav ${
                      location.pathname === "/Factsheets"
                        ? " active text-primary"
                        : "nav-link  text-grey fs-5 text-decoration-none"
                    }`}
                    to={"/Factsheets"}
                  >
                    FactSheets
                  </Link>
                </li>

                <li className="nav-item text-grey fs-5">
                  <Link
                    to="/Visualization"
                    onClick={handleDataVisualizationClick}
                    className={`nav-link custom-nav ${
                      location.pathname === "/Visualization"
                        ? "active text-primary"
                        : "text-grey fs-5 text-decoration-none"
                    }`}
                  >
                    Data Visualization
                  </Link>
                </li>

                <li className="nav-item text-grey fs-5">
                  <Link
                    className={` nav-link custom-nav ${
                      location.pathname === "/pages/initiative"
                        ? " active text-primary"
                        : "nav-link  text-grey fs-5 text-decoration-none"
                    }`}
                    to={"/pages/initiative"}
                  >
                    Initiatives
                  </Link>
                </li>

                <li className="nav-item text-grey fs-5">
                  <Link
                    className={` nav-link custom-nav ${
                      location.pathname === "/pages/methods"
                        ? " active text-primary"
                        : "nav-link  text-grey fs-5 text-decoration-none"
                    }`}
                    to={"/pages/methods"}
                  >
                    Methods
                  </Link>
                </li>

                <li className="nav-item text-grey fs-5">
                  <Link
                    className={` nav-link custom-nav ${
                      location.pathname === "/pages/help"
                        ? " active text-primary"
                        : "nav-link  text-grey fs-5 text-decoration-none"
                    }`}
                    to={"/pages/help"}
                  >
                    Help
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-auto d-none d-md-flex align-items-center">
              <div className="d-flex ms-auto">
                {!isAuthenticated ? (
                  <li className="nav-item ms-auto text-grey fs-5 list-unstyled">
                    <Link
                      className={`nav-link custom-nav ${
                        location.pathname === "/Login"
                          ? " active text-primary"
                          : "nav-link text-grey fs-5 text-decoration-none"
                      }`}
                      to={"/Login"}
                    >
                      Login
                    </Link>
                  </li>
                ) : (
                  <div className="dropdown">
                    <button
                      className="btn  ms-auto me-3 d-flex align-items-center justify-content-center"
                      type="button"
                      id="profileDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-person-circle fs-2 mr-1" />
                    </button>
                    <ul
                      className="dropdown-menu dropdown-menu-end"
                      aria-labelledby="profileDropdown"
                    >
                      <li>
                        <Link className="dropdown-item" to={"/Profile"}>
                          Profile
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to={"/Changepassword"}>
                          Change Password
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile slide-down menu (visible on small screens) */}
            <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
              <div className="mobile-links">
                <Link
                  to={"/"}
                  className={location.pathname === "/" ? "active" : ""}
                  onClick={() => setMobileOpen(false)}
                >
                  Home
                </Link>
                <Link
                  to={"/Factsheets"}
                  className={
                    location.pathname === "/Factsheets" ? "active" : ""
                  }
                  onClick={() => setMobileOpen(false)}
                >
                  FactSheets
                </Link>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setMobileOpen(false);
                    handleDataVisualizationClick(e);
                  }}
                >
                  Data Visualization
                </button>
                <Link
                  to={"/pages/initiative"}
                  className={
                    location.pathname === "/pages/initiative" ? "active" : ""
                  }
                  onClick={() => setMobileOpen(false)}
                >
                  Initiatives
                </Link>
                <Link
                  to={"/pages/methods"}
                  className={
                    location.pathname === "/pages/methods" ? "active" : ""
                  }
                  onClick={() => setMobileOpen(false)}
                >
                  Methods
                </Link>
                <Link
                  to={"/helpSection"}
                  className={
                    location.pathname === "/helpSection" ? "active" : ""
                  }
                  onClick={() => setMobileOpen(false)}
                >
                  Help
                </Link>
                {!isAuthenticated ? (
                  <Link
                    to={"/Login"}
                    className={location.pathname === "/Login" ? "active" : ""}
                    onClick={() => setMobileOpen(false)}
                  >
                    Login
                  </Link>
                ) : (
                  <>
                    <Link to={"/Profile"} onClick={() => setMobileOpen(false)}>
                      Profile
                    </Link>
                    <Link
                      to={"/Changepassword"}
                      onClick={() => setMobileOpen(false)}
                    >
                      Change Password
                    </Link>
                    <button
                      onClick={() => {
                        setMobileOpen(false);
                        handleLogout();
                      }}
                    >
                      Logout
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
